import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  transform(value: string[], queryString?: string): any {
    if (queryString) {
      const searchRegExp = new RegExp('^' + queryString, 'i');
      return value.filter(region => searchRegExp.test(region));
    } else {
      return value;
    }
  }
}
